import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ribbon from "./components/Ribbon";
import FeaturedDonuts from "./components/FeaturedDonuts";
import Boxes from "./components/Boxes";
import Drinks from "./components/Drinks";
import Story from "./components/Story";
import Testimonials from "./components/Testimonials";
import OrderOnline from "./components/OrderOnline";
import Visit from "./components/Visit";
import Footer from "./components/Footer";

const Landing = () => (
  <main data-testid="landing-page" className="relative bg-[#FFFDFB] text-[#2D2327]">
    <Navbar />
    <Hero />
    <Ribbon />
    <FeaturedDonuts />
    <Boxes />
    <Drinks />
    <Story />
    <Testimonials />
    <OrderOnline />
    <Visit />
    <Footer />
  </main>
);

function App() {
  useEffect(() => {
    document.title = "DonDonuts by Konticode";
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
